import { render, staticRenderFns } from "./partnerReportDetail.vue?vue&type=template&id=5a573435&"
import script from "./partnerReportDetail.vue?vue&type=script&lang=js&"
export * from "./partnerReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./partnerReportDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports